import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { Button } from '@mui/material';

export const GuestInfoModal = props => {
  const { isOpen, onClose, languageData, userEmail } = props;
  if (!isOpen) return null;

  return (
    <FlexContainer
      className={
        'pos-fixed align-items-center justify-center pad20 left0 right0 '
      }
      style={{
        top: '220px',
      }}
      onClick={onClose}
    >
      <FlexContainer
        className={
          'flex-column bgGradientRoseReverse grayShadowBottom border-rad16px pad12 width100'
        }
        onClick={e => e.stopPropagation()}
      >
        <FlexContainer className="flex-column ">
          <strong>
            <Label className="text-18 fontWhite margb8">
              {languageData === 'EN' ? 'Yaay!' : '¡Bien!'}
            </Label>
          </strong>
        </FlexContainer>

        <FlexContainer className="flex-column margb20">
          <Label className={'text-12 fontWhite margb8 lineHeight-1-5'}>
            {languageData === 'EN'
              ? `We've just sent a one-tap login link to ${
                  userEmail || 'your email'
                }`
              : `Acabamos de enviar un enlace de inicio de sesión de un toque a ${
                  userEmail || 'tu correo'
                }`}
          </Label>
          <Label className="text-12 fontWhite lineHeight-1-5 margb10">
            {languageData === 'EN'
              ? 'Check your inbox to get started!'
              : '¡Revisa tu bandeja de entrada para comenzar!'}
          </Label>
        </FlexContainer>

        <FlexContainer className="justify-center padl100">
          <Button
            onClick={onClose}
            className={'bgGradientBlue '}
            sx={{
              padding: '8px 16px',
              borderRadius: '11px',
              color: 'white',
              textTransform: 'none',
              minWidth: '80px',
              '&:hover': {
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            {languageData === 'EN' ? 'Got It!' : '¡Entendido!'}
          </Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default GuestInfoModal;
